import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Badge,
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	ModalBody,
	ModalHeader,
	Row
} from "reactstrap";
import * as api from "services/api";
import { toast } from "react-toastify";
import { getCompanyById } from "../actions";
import dayjs from "dayjs";

const ReleaseAccessIntegration = () => {
	const dispatch = useDispatch();

	const { item: company } = useSelector(state => state.companyDetail);
	const { token, user: currentUser } = useSelector(state => state.login);

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [modal, setModal] = useState(false);
	const [localData, setLocalData] = useState(null);

	const toggleModal = () => setModal(prev => !prev);

	const data = localData || company;
	const isReleased = !!data?.apto;

	const handleSubmit = async () => {
		setIsSubmitting(true);

		const endpoint = isReleased
			? `/company/revoke-access/${company._id}`
			: `/company/release-access/${company._id}`;

		const response = await api.sendPut(endpoint, {}, {
			Authorization: "Bearer " + token
		});

		if (!response) {
			toast.error("Erro de conexão.");
			setIsSubmitting(false);
			return;
		}

		const result = await response.json();

		if (result.isValid) {
			setLocalData({
				...result.model,
				accessReleasedBy: result.model?.accessReleasedBy && currentUser
					? { _id: result.model.accessReleasedBy, name: currentUser.name }
					: result.model?.accessReleasedBy
			});
			toggleModal();
			toast.success(
				isReleased
					? "Acesso removido com sucesso!"
					: "Acesso liberado com sucesso!"
			);
			dispatch(getCompanyById(company._id, err => { if (err) console.log(err); }));
		} else {
			toast.error(
				result.errors?.message ||
					result.errors?.default ||
					"Houve um erro ao processar a ação."
			);
			toggleModal();
		}

		setIsSubmitting(false);
	};

	return (
		<Card>
			<CardBody>
				<Row id="release-access-title">
					<Col>
						<h4>
							<strong>Gestão de Pagamentos</strong>
						</h4>
					</Col>
				</Row>

				<div className="topbar__menu-divider" />

				<Row className="mt-3">
					<Col>
						<p>
							<strong>Status:</strong>
							<br />
							{isReleased ? (
								<Badge color="success">Apto</Badge>
							) : (
								<Badge color="secondary">Não apto</Badge>
							)}
						</p>
					</Col>

					{data?.accessReleasedAt && (
						<Col>
							<p>
								<strong>{isReleased ? "Data de Liberação:" : "Data de Remoção:"}</strong>
								<br />
								<span>
									{dayjs(data.accessReleasedAt).format("DD/MM/YYYY HH:mm")}
								</span>
							</p>
						</Col>
					)}

					{data?.accessReleasedBy && (
						<Col>
							<p>
								<strong>{isReleased ? "Liberado por:" : "Removido por:"}</strong>
								<br />
								<span>
									{data.accessReleasedBy?.name || data.accessReleasedBy}
								</span>
							</p>
						</Col>
					)}

					<Col className="text-right">
						<Button
							color={isReleased ? "danger" : "primary"}
							onClick={toggleModal}
						>
							{isReleased ? "Remover Acesso" : "Liberar Acesso"}
						</Button>
					</Col>
				</Row>

				<Modal isOpen={modal} toggle={toggleModal}>
					<ModalHeader
						toggle={toggleModal}
						className="card__title bold-text m-0"
					>
						<strong>
							{isReleased
								? "Remover Acesso à Gestão de Pagamentos"
								: "Liberar Gestão de Pagamentos"}
						</strong>
					</ModalHeader>

					<ModalBody>
						{isReleased ? (
							<>
								<p className="h6">
									Deseja <strong>remover</strong> o acesso à{" "}
									<strong>Gestão de Pagamentos</strong> desta empresa?
								</p>
								<p>
									O campo <strong>apto</strong> será atualizado para{" "}
									<strong>Não apto</strong>.
								</p>
							</>
						) : (
							<>
								<p className="h6">
									Deseja liberar o acesso à{" "}
									<strong>Gestão de Pagamentos</strong> para esta empresa?
								</p>
								<p>
									Ao confirmar, as seguintes informações serão registradas:
								</p>
								<ul>
									<li>
										O campo <strong>não apto</strong> será atualizado para{" "}
										<strong>Apto</strong>
									</li>
									<li>A data e hora da liberação serão registradas</li>
									<li>O usuário responsável pela ação será registrado</li>
								</ul>
								<p className="text-muted small">
									Esta ação só pode ser executada para clientes com contratação
									válida.
								</p>
							</>
						)}

						<div className="d-flex justify-content-between mt-3">
							<Button type="button" onClick={toggleModal} disabled={isSubmitting}>
								Cancelar
							</Button>
							<Button
								color={isReleased ? "danger" : "primary"}
								onClick={handleSubmit}
								disabled={isSubmitting}
							>
								{isSubmitting
									? "Aguarde..."
									: isReleased
									? "Confirmar Remoção"
									: "Confirmar Liberação"}
							</Button>
						</div>
					</ModalBody>
				</Modal>
			</CardBody>
		</Card>
	);
};

export default ReleaseAccessIntegration;
